@let templates = this.list$ | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <div class="content mt-space-md flex-column g-space-md">
      <div class="space-between">
        <cam-grid-tag class="d-flex" [gridId]="this.id" [showResultCount]="true"></cam-grid-tag>
        <cam-grid-control
          class="d-flex"
          [gridId]="this.id"
          [show]="{ fields: true, filters: true, search: true, switchView: false, views: false }"
        ></cam-grid-control>
      </div>

      <cam-empty [isEmpty]="!templates || templates.length === 0">
        @if (templates && templates.length) {
          <ng-container>
            <cam-ag-grid
              [gridId]="this.id"
              defaultDisplay="table"
              rowSize="grid"
              [data]="templates"
              [fieldsOverrides]="this.fieldsOverrides"
              [gridOptions]="{
                domLayout: 'autoHeight',
              }"
            ></cam-ag-grid>
          </ng-container>
        }
      </cam-empty>
    </div>
  </cam-error>
</cam-loader>
